import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

// CSS
import "./Notification.css";

const Notification = ({ message, type, onClose, NotificationKey, onClick }) => {
  const notRef = useRef(null);
  const startXRef = useRef(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(NotificationKey);
    }, 8000);
    return () => clearTimeout(timer);
  }, [onClose, NotificationKey]);

  useEffect(() => {
    const notification = notRef.current;
    if (!notification) return;

    const pressed = (e) => {
      e.preventDefault();
      const x = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
      startXRef.current = x;
      window.addEventListener("mouseup", letGo);
      window.addEventListener("touchend", letGo);
    };

    const letGo = (e) => {
      e.preventDefault();
      const x =
        e.type === "touchend"
          ? (e.changedTouches[0] || e.targetTouches[0]).clientX
          : e.clientX;
      if (x > startXRef.current + 50 || x < startXRef.current - 50) {
        onClose(NotificationKey);
      }
      removeListeners();
    };

    notification.addEventListener("mousedown", pressed);
    notification.addEventListener("touchstart", pressed, { passive: true });

    const removeListeners = () => {
      notification.removeEventListener("mousedown", pressed);
      notification.removeEventListener("touchstart", pressed);
      window.removeEventListener("mouseup", letGo);
      window.removeEventListener("touchend", letGo);
    };

    return () => {
      removeListeners();
    };
  }, [onClose, NotificationKey]);
  if (!message) return null;

  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setTimeout(() => {
      onClose(NotificationKey);
    }, 10);
  };

  return (
    <motion.div
      className={`notification ${type} ${NotificationKey}`}
      layout
      ref={notRef}
      key={NotificationKey}
      whileHover={{ scale: 1.02 }}
      onClick={() => {}}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 30,
      }}
    >
      <span
        className="notification-content"
        onClick={onClick ? () => onClick() : () => {}}
      >
        {message}
      </span>

      <motion.button
        className="notification-close-btn"
        onClick={handleCloseClick}
        onTouchEnd={handleCloseClick}
        whileHover={{ scale: 1.2, transition: { duration: 0.1 } }}
        whileTap={{
          scale: 0.9,
          transition: { duration: 0.1 },
        }}
        transition={{ type: "spring", stiffness: 400 }}
        aria-label="Close notification"
        tabIndex={1}
      >
        &times;
      </motion.button>
    </motion.div>
  );
};

export default Notification;
